export class CreateFootcareAssessment {
    AssessmentGrading: string=''
    IsActive: boolean
}

export class EditFootcareAssessment{
    id: any
    AssessmentGrading: string=''
    IsActive: boolean
}